export const companyTypeList=[//企业类型
    {name:'中介公司企业',id:'1'},{name:'开发商企业',id:'2'},{name:'长租公寓企业',id:'3'},{name:'悦居企业',id:'4'},{name:'贴心服务企业',id:'5'}
];
export const houseTypeList=[//房源类型
    {name:'经纪人房源',id:'1'},{name:'平台房源',id:2}
];
export const houseStateList=[//房源状态
    {name:'待实勘',id:'0'},{name:'审核中',id:'1'},{name:'发布中',id:'2'},{name:'审核未通过',id:'3'},{name:'已下线',id:'4'},{name:'锁定',id:'5'},{name:'交易中',id:'6'},{name:'交易完成',id:'7'}
];
export const casusTypeList=[//案例类型
    {name:'出租',id:'1'},{name:'出售',id:'0'}
];
export const cardTypeList=[//证件类型
    {name:'居民身份证',id:'15802580'},{name:'军官证',id:'15802581'},{name:'户口簿',id:'15802582'},{name:'护照',id:'15802583'},{name:'港澳居民来往内地通行证',id:'15802584'},{name:'台湾居民来往大陆通行证',id:'15802585'},{name:'社会统一信用代码',id:'15802586'}
];	
	
	
export const hasbtn=(menulist,btn)=>{
    for(var i=0;i< menulist.length;i++){
        if(menulist[i].path==btn){
            return true;
        }else{
            if(menulist[i].children && menulist[i].children.length>0){
                for(var j=0;j< menulist[i].children.length;j++){
                    if(menulist[i].children[j].path==btn){
                        return true;
                    }    
                }    
            }
        }
    }
    return false
};
	
	